var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Search/search.model.ts";
import "core-js/modules/es.array.some.js";
import { combine } from 'effector';
import * as api from '@gmini/sm-api-sdk';
export var executeNodeSearch = combine({
  ɔ: [[api.ElementPathClassifier.getElementPath.defaultContext.pending$, api.UserClassifier.findDynamicGroups.defaultContext.pending$, api.UserClassifier.fetchElementRefs.defaultContext.pending$], function (pending) {
    return pending.some(Boolean);
  }],
  config: {
    name: "executeNodeSearch",
    sid: "-8nvzb3"
  }
});
export var executeNodeSearchPending = executeNodeSearch;